<template>
  <button
    v-if="!editMode && isEditable && show"
    :disabled="loading || disabled"
    :class="['button align-center margin', widthClass]"
    :data-test-policy-activate-edit-mode-button="!secondary"
    :data-test-policy-activate-edit-mode-button-secondary="secondary"
    @click="$store.dispatch('policy/activateEditMode', policyId)"
  >
    <span v-html="editModeButtonLabel" />
    <div v-show="loading" class="spinner spinner-button show-for-large" />
  </button>
</template>

<script>
import Utility from '@/common/UtilityFunctions.js';

export default {
  name: 'ActivateEditModeButton',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: 8
    }
  },
  computed: {
    editMode() {
      return this.$store.state.policy.editMode;
    },
    editModeButtonLabel() {
      return this.$store.getters['policy/editModeButtonLabel'];
    },
    isEditable() {
      return this.$store.getters['policy/isEditable'];
    },
    loading() {
      return this.$store.state.policy.loading;
    },
    policyId() {
      return Utility.getQueryVariable('id');
    },
    widthClass() {
      return 'medium-' + String(this.width);
    },
    vm() {
      return this;
    }
  }
};
</script>
